import React from "react";
import Tooltip from "../components/Tooltip";
import Content0 from '../components/DeepDive/Content0';
import Content1 from '../components/DeepDive/Content1';
import Content2 from '../components/DeepDive/Content2';
import Content3 from '../components/DeepDive/Content3';

export const OverlayData = [
  {
    id: 0,
    position: "topRight",
    size: "medium",
    hold: 1.25,
    seconds: 0,
    content: (
      <>To understand the impact a <Tooltip>MAC</Tooltip> infection can have on your health, let’s first look at how <Tooltip>MAC</Tooltip> <Tooltip>bacteria</Tooltip> gets inside the lungs.</>
    ),
    disclaimer: true
  },
  {
    id: 1,
    position: "topRight",
    size: "medium",
    hold: 2.0,
    seconds: 3.451,
    content: (
      <><Tooltip>MAC</Tooltip> <Tooltip>bacteria</Tooltip> are everywhere: in water, soil, and floating in the air we breathe.</>
    )
  },
  {
    id: 2,
    position: "topRight",
    size: "small",
    hold: 2,
    seconds: 5.603,
    content: (
      <>These <Tooltip>bacteria</Tooltip> are usually harmless. But for people with a history of lung conditions like <Tooltip>bronchiectasis</Tooltip>, <Tooltip>COPD</Tooltip>, or <Tooltip>asthma</Tooltip>, they can pose a threat.</>
    )
  },
  {
    id: 3,
    position: "bottomRight",
    size: "small",
    hold: 1.5,
    seconds: 9.4,
    deepdive: <>Deep dive: Are you at risk?</>,
    deepdiveIndex: 0,
    content: (
      <>When the <Tooltip>bacteria</Tooltip> enter the lungs, they can multiply.</>
    )
  },
  {
    id: 4,
    position: "topRight",
    size: "small",
    hold: 1.5,
    seconds: 12.44,
    content: (
      <>The immune system will try to destroy the <Tooltip>bacteria</Tooltip> by sending <Tooltip>macrophages</Tooltip>, white blood cells with the job of killing outside invaders.</>
    )
  },
  {
    id: 5,
    position: "topLeft",
    size: "medium",
    hold: 2,
    seconds: 14.66,
    content: (
      <>However, <Tooltip>MAC</Tooltip> <Tooltip>bacteria</Tooltip> have a barrier of protection that makes them hard to destroy. Many <Tooltip>bacteria</Tooltip> survive and multiply inside the <Tooltip>macrophage</Tooltip>, eventually destroying it and getting free.</>
    )
  },
  {
    id: 6,
    position: "bottomCenter",
    size: "large",
    hold: 1.5,
    seconds: 18.5,
    content: (
      <>These <Tooltip>bacteria</Tooltip> cause <Tooltip>MAC lung disease</Tooltip>, a progressive disease that can cause permanent damage throughout the lungs. This damage can happen with or without symptoms and can be prevented if the disease is treated early.</>
    )
  },
  {
    id: 7,
    position: "bottomCenter",
    size: "large",
    hold: 1.5,
    seconds: 21.11,
    content: (
      <>There are 2 types of <Tooltip>MAC</Tooltip> lung damage in this <Tooltip>CT scan</Tooltip>: the thick-walled, air-filled <Tooltip>lung cavities</Tooltip> and the dark spots known as <Tooltip>nodules</Tooltip>. First, let’s explore the <Tooltip>nodules</Tooltip>.</>
    )
  },
  {
    id: 8,
    position: "centerCenter",
    size: "small",
    hold: 0.7,
    interstitial: true,
    seconds: 22.8,
    content: (
      <>Nodules</>
    )
  },
  {
    id: 9,
    position: "bottomLeft",
    size: "medium",
    hold: 1.3,
    seconds: 24.02,
    content: (
      <>This type of damage forms when the body sends <Tooltip>macrophages</Tooltip> to contain the infection from the rest of the lung. These cells surround the infection and clump together.</>
    )
  },
  {
    id: 10,
    position: "bottomLeft",
    size: "small",
    hold: 1,
    seconds: 26.2,
    content: (
      <>Unable to clear the infection, the body sends more and more <Tooltip>macrophages</Tooltip> to the site.</>
    ),
    disclaimer: true
  },
  {
    id: 11,
    position: "bottomLeft",
    size: "small",
    hold: 1.5,
    seconds: 27.5,
    content: (
      <>Over time the <Tooltip>macrophages</Tooltip> harden, resulting in a <Tooltip>nodule</Tooltip> that continues to grow.</>
    )
  },
  {
    id: 12,
    position: "bottomLeft",
    size: "small",
    hold: 1.5,
    seconds: 30.5,
    content: (
      <>As <Tooltip>MAC lung disease</Tooltip> progresses, more infection sites and eventually more <Tooltip>nodules</Tooltip> can appear.</>
    )
  },
  {
    id: 13,
    position: "topLeft",
    size: "small",
    hold: 1.5,
    seconds: 35.8,
    deepdive: <>Deep dive: Managing MAC</>,
    deepdiveIndex: 1,
    content: (
      <>As <Tooltip>nodules</Tooltip> grow, they can press on airways, causing coughing, wheezing, and shortness of breath. If you have these symptoms, talk to your doctor right away about treatment. This type of lung damage can get worse over time.</>
    )
  },
  {
    id: 14,
    position: "centerCenter",
    size: "large",
    hold: 1.8,
    interstitial: true,
    seconds: 38.3,
    content: (
      <>Lung Cavities</>
    )
  },
  // LEFT OFF HERE
  {
    id: 15,
    position: "bottomRight",
    size: "large",
    hold: 2,
    seconds: 40.6,
    content: (
      <><Tooltip>Lung cavities</Tooltip> can pose a serious threat to people with <Tooltip>MAC lung disease</Tooltip>.</>
    )
  },
  {
    id: 16,
    position: "topLeft",
    size: "medium",
    hold: 3,
    seconds: 45.5,
    content: (
      <>These occur when an infection damages an area of the lungs and kills the lung tissue. The body removes the dead lung tissue through the airways, and an empty space is left behind.</>
    ),
    disclaimer: true
  },
  {
    id: 17,
    position: "topLeft",
    size: "small",
    hold: 2.5,
    seconds: 49,
    content: (
      <>Like <Tooltip>nodules</Tooltip>, this type of damage can grow with time.</>
    )
  },
  {
    id: 18,
    position: "topLeft",
    size: "small",
    hold: 2.5,
    seconds: 56,
    deepdive: <>Deep dive: Testing lung function</>,
    deepdiveIndex: 2,
    content: (
      <>More may appear over time, causing irreversible damage and parts of the lungs to stop working. This type of damage can be prevented, which is why it’s important to treat <Tooltip>MAC lung disease</Tooltip> as soon as possible, before it progresses.</>
    )
  },
  {
    id: 19,
    position: "centerCenter",
    size: "medium",
    hold: 1.8,
    interstitial: true,
    seconds: 59.5,
    content: (
      <>Respiratory Failure</>
    )
  },
  {
    id: 20,
    position: "topLeft",
    size: "medium",
    hold: 2,
    seconds: 63.2,
    content: (
      <>The collective damage of <Tooltip>MAC lung disease</Tooltip> can put one at a greater risk of <Tooltip>chronic respiratory failure</Tooltip>.</>
    )
  },
  {
    id: 21,
    position: "topLeft",
    size: "medium",
    hold: 3,
    seconds: 66,
    content: (
      <>This type of damage is rare, and may require hospitalization, <Tooltip>supplemental oxygen</Tooltip>, or a <Tooltip>ventilator</Tooltip> to keep vital organs from failing. In severe cases, <Tooltip>lung resection</Tooltip> surgery may be considered.</>
    )
  },
  {
    id: 22,
    position: "centerCenter",
    size: "half",
    hold: 2,
    interstitial: true,
    seconds: 70,
    content: (
      <>Is there a way you can prevent future lung damage?</>
    )
  },
  {
    id: 23,
    position: "topLeft",
    size: "medium",
    hold: 3,
    seconds: 72.5,
    deepdive: <>Deep dive: A patient takes action</>,
    deepdiveIndex: 3,
    content: (
      <>Getting MAC-negative as soon as possible can help you avoid future lung damage. Create a plan with your doctor to get MAC-negative as soon as possible.</>
    )
  },
];

export const DeepDiveData = [
  {
    id: 0,
    seconds: 9.88,
    hold: "long",
    content: <Content0 />,
    button: "Deep dive: Are you at risk?",
    position: "bottomRight",
  },
  {
    id: 1,
    seconds: 35,
    hold: "long",
    content: <Content1 />,
    button: "Deep dive: Managing MAC",
    position: "bottomRight",
  },
  {
    id: 2,
    seconds: 46.45,
    hold: "long",
    content: <Content2 />,
    button: "Deep dive: Testing lung function",    
    position: "bottomRight",
  },
  {
    id: 3,
    seconds: 61.5,
    hold: "long",
    content: <Content3 />,
    button: "Deep dive: A patient takes action",    
    position: "bottomRight",
  }
];